import { render } from "./SlCategoryModal.vue?vue&type=template&id=5cd2bd4c&scoped=true"
import script from "./SlCategoryModal.vue?vue&type=script&lang=js"
export * from "./SlCategoryModal.vue?vue&type=script&lang=js"

import "./SlCategoryModal.vue?vue&type=style&index=0&id=5cd2bd4c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd2bd4c"]])

export default __exports__